import { inject, Injectable } from '@angular/core';
import { Functions } from '@angular/fire/functions';
import { httpsCallable } from 'firebase/functions';
import { WINDOW } from 'moddy/common';

@Injectable({
    providedIn: 'root'
})
export class TelegramBotIntegrationService {
    private readonly functions = inject(Functions);
    private readonly getTelegramIntegrationLink = httpsCallable(
        this.functions,
        'getTelegramIntegrationLink'
    );
    private readonly window = inject(WINDOW);

    public async integrate(): Promise<void> {
        const response = (await this.getTelegramIntegrationLink()) as { data: string };

        if (response?.data) {
            this.window.open(response.data, '_blank');
        }
    }
}
